const modalReducer = (state, { type, payload }) => {
  switch (type) {
    case 'OPEN':
      return { ...state, isOpen: true, ...payload }
    case 'CLOSE':
      return { isOpen: false, children: null }
  }
}

export default modalReducer
